import { inject, observer } from "mobx-react";
import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Loading, Text } from "../../components/common";
import { IAuthModel } from "../../modules/auth/AuthModel";
import { hasPermission } from "../../utils/render-by-permission";
// import { OidcService } from "./../../modules/auth/OidcService";
import { OidcServiceFactory  } from './../../modules/auth/OidcServiceFactory';

interface IPrivateRoute extends RouteComponentProps<any>, WithTranslation {
  component: any;
  permissionCode: string[];
  notStrict?: boolean;
  authStore?: IAuthModel;
}

@inject("authStore")
@observer
class PrivateRoute extends React.Component<IPrivateRoute, any> {
  // public oidcService = new OidcService();
  public render() {
    const { component, permissionCode, notStrict, authStore, ...rest } =
      this.props;

    if (!authStore) {
      return <Loading active inverted />;
    }

    // Check for inactive user first
    if (authStore.userProfile && !authStore.userProfile.isActive) {
      authStore.sign_out();
      OidcServiceFactory.logout(this.props.history);
      return null;
    }

    // Then check loading state
    if (authStore.loading) {
      return <Loading active inverted />;
    }

    const hasRequiredPermissions = notStrict
      ? permissionCode.some((code: string) => hasPermission(code))
      : permissionCode.every((code: string) => hasPermission(code));

    return (
      <React.Fragment>
        {hasRequiredPermissions ? (
          React.cloneElement(component, { ...rest })
        ) : (
          <Text>{"คุณไม่มีสิทธิ์ในการเข้าถึงหน้านี้!"}</Text>
        )}
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(PrivateRoute));
